export default __webpack_public_path__ + "static/media/desk-clean5.f4380814.png";